
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetobhimashankarcab() {



  const cardData =
  {
    keyword: ' Pune to Bhimashankar Cab',
    heading: 'Vaishnavi Travels: Pune to Bhimashankar Cab',
    headingDescription: 'Vaishnavi Travels provides dependable and affordable Pune to Bhimashankar Cab service, perfect for pilgrims, families, and small groups planning a comfortable journey. Our cabs are well-maintained with air-conditioning, spacious seating, and experienced chauffeurs to ensure a smooth ride on the scenic Pune–Bhimashankar route. With timely pickups, flexible booking options, and safe driving, we make your religious yatra stress-free and convenient. Whether it’s a one-day darshan trip or an extended pilgrimage, Vaishnavi Travels guarantees reliable, safe, and comfortable cab services from Pune to Bhimashankar Jyotirlinga.',

    top: 'Top Places to Visit in Bhimashankar with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "description": "Bhimashankar Temple, one of the 12 Jyotirlingas of Lord Shiva, is nestled in the Sahyadri hills about 110 km from Pune. Built in Nagara-style architecture, the shrine has a swayambhu lingam believed to be self-manifested. Devotees throng here during Mahashivratri and Shravan for darshan. Surrounded by forests, the temple radiates peace and divinity. The chants of ‘Har Har Mahadev’ fill the air with energy. Bhimashankar is Maharashtra’s sacred pilgrimage and spiritual haven."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Spread over 130 sq km, Bhimashankar Wildlife Sanctuary surrounds the temple and protects rare flora and fauna. It is home to the endangered Indian Giant Squirrel (Shekru), Maharashtra’s state animal. Nature lovers enjoy trekking, birdwatching, and exploring the lush green forests. Monsoon enhances its beauty with mist, waterfalls, and streams. The sanctuary is also a biodiversity hotspot with medicinal plants. Bhimashankar Wildlife Sanctuary is the perfect blend of devotion and nature."
  },
  {
    "title": "Hanuman Lake",
    "description": "Hanuman Lake, located near Bhimashankar, is a serene natural spot amidst dense forests. Legend associates it with Lord Hanuman, adding spiritual significance. Tourists visit for short treks, picnics, and birdwatching. Its calm waters and refreshing greenery create a peaceful escape. During monsoon, the area becomes vibrant with flowing streams. Hanuman Lake is Bhimashankar’s quiet retreat for nature and devotion."
  },
  {
    "title": "Gupt Bhimashankar",
    "description": "Gupt Bhimashankar is a lesser-known shrine located deep inside the forest, believed to be another manifestation of Lord Shiva. Pilgrims trek through lush greenery and rocky trails to reach this spot. The small shrine radiates mystical energy and offers peace away from the crowds. It is a hidden gem for meditation and spiritual seekers. The journey itself is filled with natural beauty. Gupt Bhimashankar is Bhimashankar’s secret abode of faith."
  },
  {
    "title": "Nagphani Point (Duke’s Nose)",
    "description": "Nagphani Point, also called Duke’s Nose, is a cliff-top viewpoint offering panoramic views of the Sahyadris. The cliff resembles a snake’s hood, hence the name Nagphani. Trekkers and adventure enthusiasts love hiking up here, especially during sunrise and sunset. Monsoon clouds and mist create magical scenery. Photographers capture breathtaking landscapes from this spot. Nagphani Point is Bhimashankar’s thrilling adventure and scenic highlight."
  },
  {
    "title": "Bombay Point",
    "description": "Bombay Point is a popular viewpoint in Bhimashankar that overlooks valleys and forests stretching towards Mumbai. It was historically a route connecting the Deccan plateau to the coastal city. Tourists enjoy spending evenings here watching sunsets and misty horizons. The spot is calm, away from the temple crowds. Cool breezes and lush surroundings enhance the experience. Bombay Point is Bhimashankar’s scenic retreat for relaxation."
  },
  {
    "title": "Ahupe Ghat",
    "description": "Ahupe Ghat is a breathtaking mountain pass near Bhimashankar offering trekking trails and panoramic views. The trail passes through tribal villages, waterfalls, and dense forests. From the top, trekkers see sweeping views of the Konkan plains and valleys. Monsoon transforms the area into a green paradise. It is popular among adventure enthusiasts and seasoned hikers. Ahupe Ghat is Bhimashankar’s ultimate trekking and nature escape."
  },
  {
    "title": "Sahyadri Trekking Trails",
    "description": "Bhimashankar is surrounded by multiple trekking trails through the Sahyadri ranges. Routes from Khandas, Karjat, and Ahupe are popular among adventure seekers. Trekkers encounter waterfalls, streams, and dense jungle paths filled with exotic flora and fauna. The trails vary from easy to challenging, suiting different levels. Monsoon and winter are ideal for treks. Bhimashankar’s trekking trails are Maharashtra’s favorite adventure and pilgrimage paths."
  },
  {
    "title": "Sacred Groves of Bhimashankar",
    "description": "Bhimashankar is also known for its sacred groves, forest patches preserved by local tribes for centuries. These groves are believed to be blessed by deities and remain untouched, protecting rare biodiversity. Visitors find them mystical and spiritually uplifting. The tradition shows harmony between faith and conservation. Pilgrims often combine darshan with a walk through these groves. Sacred Groves are Bhimashankar’s living legacy of ecology and devotion."
  },
  {
    "title": "Tribal Villages Around Bhimashankar",
    "description": "The tribal villages near Bhimashankar provide cultural insights into rural Maharashtra. Visitors experience traditional lifestyles, local food, and handmade products like honey and handicrafts. During festivals, these villages resonate with folk songs and dances. Tourists enjoy engaging with the warm and welcoming locals. The simple lifestyle adds depth to the pilgrimage experience. Tribal villages are Bhimashankar’s cultural soul complementing its spiritual aura."
  }
],


    "services": [
    {
      "name": "Pune to Bhimashankar Taxi Booking",
      "description": "Book a reliable taxi from Pune to Bhimashankar for a hassle-free pilgrimage or leisure trip. Our service ensures prompt pickups, comfortable seating, and smooth navigation through the scenic routes leading to the Bhimashankar temple. Suitable for solo travelers, families, and groups looking for convenience and safety."
    },
    {
      "name": "One Way Cab to Bhimashankar",
      "description": "Choose our one-way cab service from Pune to Bhimashankar for straightforward travel without the need for return arrangements. Ideal for travelers with onward plans or those combining multiple destinations. Enjoy clean, well-maintained vehicles with experienced drivers familiar with the terrain."
    },
    {
      "name": "Round Trip Bhimashankar Taxi",
      "description": "Opt for a round-trip taxi from Pune to Bhimashankar, designed for travelers who want to explore the temple and return comfortably the same day. Flexible pickup and drop timings, driver waiting options, and efficient route planning make your pilgrimage smooth and stress-free."
    },
    {
      "name": "AC Cab Pune to Bhimashankar",
      "description": "Travel in cool comfort with our air-conditioned taxi service from Pune to Bhimashankar. Perfect for hot weather or longer journeys, these vehicles feature powerful AC units, spacious interiors, and ergonomic seating to keep passengers refreshed throughout the trip."
    },
    {
      "name": "Non AC Bhimashankar Cab",
      "description": "Budget-friendly non-AC taxi options from Pune to Bhimashankar without compromising on safety or comfort. Ideal for short trips or when AC is not a priority, these cabs provide reliable transportation with courteous drivers and timely service."
    },
    {
      "name": "SUV Taxi Bhimashankar Pune",
      "description": "Hire a sturdy SUV taxi from Pune to Bhimashankar for group travel, family outings, or when extra luggage space is required. These vehicles offer superior ground clearance and robust build quality, making them perfect for rough or hilly terrain. Equipped with comfortable seats and ample cabin space."
    },
    {
      "name": "BOH Pilgrimage Bhimashankar Cab",
      "description": "Specialized taxi service for pilgrims visiting Bhimashankar under the BOH (Brahma, Omkareshwar, and other holy) pilgrimage circuit. Experience respectful, timely service with drivers knowledgeable about religious sites and routes, ensuring a spiritually fulfilling journey."
    },
    {
      "name": "Bhimashankar Darshan Taxi",
      "description": "Book a dedicated Bhimashankar darshan taxi for hassle-free temple visits. Our service includes door-to-door pickup, assistance with local travel around the temple, and flexible return options, making your spiritual trip comfortable and well-organized."
    },
    {
      "name": "Budget Cab Pune Bhimashankar",
      "description": "Affordable cab rental service from Pune to Bhimashankar for travelers looking for economical options. These budget cabs maintain high standards of hygiene, punctuality, and driver professionalism while keeping fares competitive."
    },
    {
      "name": "Online Bhimashankar Cab Booking",
      "description": "Conveniently book your Pune to Bhimashankar taxi online with instant confirmation, transparent pricing, and multiple vehicle options. Choose your preferred cab type, schedule, and add special requests with ease, supported by 24/7 customer service."
    },
    {
      "name": "Bhimashankar Tempest Cab",
      "description": "Experience premium travel with our Bhimashankar Tempest cabs, featuring modern interiors, superior suspension, and advanced safety features. Ideal for travelers seeking luxury and comfort en route to the sacred temple."
    },
    {
      "name": "Group Cab Hire Bhimashankar",
      "description": "Hire spacious cabs for group travel from Pune to Bhimashankar, accommodating families, friends, or corporate groups. Vehicles are sanitized, driver-friendly, and equipped with ample luggage space to make your group journey pleasant and efficient."
    },
    {
      "name": "Bhimashankar Cab Fare Estimate",
      "description": "Get an instant fare estimate for your Pune to Bhimashankar cab booking with detailed breakdowns including distance, vehicle type, driver allowances, and taxes. Helps in budgeting your pilgrimage trip effectively and choosing the right cab service."
    }
  ],
  "tableData": [
    ["Pune to Bhimashankar Taxi Booking", "One Way Cab to Bhimashankar"],
    ["Round Trip Bhimashankar Taxi", "AC Cab Pune to Bhimashankar"],
    ["Non AC Bhimashankar Cab", "SUV Taxi Bhimashankar Pune"],
    ["BOH Pilgrimage Bhimashankar Cab", "Bhimashankar Darshan Taxi"],
    ["Budget Cab Pune Bhimashankar", "Online Bhimashankar Cab Booking"],
    ["Bhimashankar Tempest Cab", "Group Cab Hire Bhimashankar"],
    ["Bhimashankar Cab Fare Estimate"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Bhimashankar Cab Service",
    "WhyChoosedescription": "Vaishnavi Travels offers reliable and comfortable cab services from Pune to Bhimashankar, ideal for pilgrimage, weekend getaways, and family trips."
  },
  {
    "WhyChooseheading": "Multiple Cab Options to Suit Your Budget",
    "WhyChoosedescription": "Choose from a range of vehicles including Swift Dzire, Ertiga, Innova, and Urbania — all available at competitive prices."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Vehicles",
    "WhyChoosedescription": "Our cabs are regularly serviced, sanitized, and kept in excellent condition to ensure safety and comfort during your trip."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our professional drivers are familiar with the Pune–Bhimashankar route and ensure a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Enjoy fixed, all-inclusive fares with no hidden charges — covering fuel, tolls, parking, and driver allowance."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Options",
    "WhyChoosedescription": "We provide door-to-door service with flexible pickup timing, ideal for early morning temple visits or day trips."
  },
  {
    "WhyChooseheading": "Perfect for Devotees, Families, and Small Groups",
    "WhyChoosedescription": "Whether it's a spiritual visit or a leisure outing, our cabs are perfect for comfortable travel to Bhimashankar."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our team is available round-the-clock to help you with bookings, trip planning, and any travel queries."
  }
]










  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer cab services from Pune to Bhimashankar?',
      answer: 'Yes, Vaishnavi Travels provides reliable cab services from Pune to Bhimashankar, ideal for pilgrimages, family visits, or weekend getaways to the famous Jyotirlinga temple.',
    },
    {
      question: 'What types of cabs are available for the Pune to Bhimashankar route?',
      answer: 'We offer a range of vehicles including Swift Dzire, Ertiga, Innova, and Tempo Travellers depending on your group size and comfort preferences.',
    },
    {
      question: 'Are the cabs well-maintained and operated by professional drivers?',
      answer: 'Absolutely! All cabs are regularly serviced and maintained. Our professional drivers are experienced, courteous, and well-versed with the Pune to Bhimashankar route.',
    },
    {
      question: 'What is the cab fare for a trip from Pune to Bhimashankar?',
      answer: 'Cab fares typically start from ₹3,500 for a one-way trip in a sedan like Swift Dzire. Prices vary based on vehicle type, duration, and return trip options.',
    },
    {
      question: 'Can I book a round trip cab from Pune to Bhimashankar with return on the same day?',
      answer: 'Yes, Vaishnavi Travels offers flexible round trip packages from Pune to Bhimashankar with same-day return options and customizable itineraries.',
    },
    {
      question: 'How early should I book a cab for Pune to Bhimashankar?',
      answer: 'It is recommended to book at least 1-2 days in advance, especially during weekends and festive periods when temple footfall is higher.',
    },
    {
      question: 'Is doorstep pickup and drop-off available for the Pune to Bhimashankar cab service?',
      answer: 'Yes, we offer convenient doorstep pickup and drop-off within Pune and nearby areas for maximum convenience.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Prashant Naik",
    position: "Pilgrim",
    feedback:
      "I booked a cab from Vaishnavi Travels for Pune to Bhimashankar. The ride was smooth, the car was clean, and the driver knew the route well. Very professional service!",
    rating: 5,
  },
  {
    name: "Ms. Sonali Khedekar",
    position: "Frequent Traveler",
    feedback:
      "Vaishnavi Travels made our trip to Bhimashankar stress-free. The cab arrived on time, the driver was polite, and the journey was comfortable. Highly recommended!",
    rating: 5,
    style: "style-2",
  }
];






































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Cab Service",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-bhimashankar-cab.jpg",
  "description": "Book AC and Non AC cabs from Pune to Bhimashankar for one-way and round trips. Reliable taxi services including SUVs for pilgrimage, group hires, and budget-friendly fares.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-bhimashankar-cab"
  }
};



  return (
    <div>
<Helmet>
  <title>Pune to Bhimashankar Cab | AC & Non AC Taxi Booking</title>
  <meta
    name="description"
    content="Book AC and Non AC cabs from Pune to Bhimashankar for one-way and round trips. Reliable taxi services including SUVs for pilgrimage, group hires, and budget-friendly fares."
  />
  <meta
    name="keywords"
    content="Pune to Bhimashankar Taxi Booking, One Way Cab to Bhimashankar, Round Trip Bhimashankar Taxi, AC Cab Pune to Bhimashankar, Non AC Bhimashankar Cab, SUV Taxi Bhimashankar Pune, BOH Pilgrimage Bhimashankar Cab, Bhimashankar Darshan Taxi, Budget Cab Pune Bhimashankar, Online Bhimashankar Cab Booking, Bhimashankar Tempest Cab, Group Cab Hire Bhimashankar, Bhimashankar Cab Fare Estimate"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/52.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobhimashankarcab;